export function inflection(num, words) {
  const count = Math.abs(num);
  if (count === 1) return words[0];
  if (count < 5 && count > 0) return words[1];
  return words[2];
}
